const RetryIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g clipPath='url(#clip0_4840_711)'>
        <path
          d='M15.75 9H20.25V4.5'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M20.25 9.00003L17.5988 6.34878C16.0633 4.81343 13.9846 3.94529 11.8132 3.93266C9.64193 3.92002 7.55317 4.7639 6 6.28128'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.25 15H3.75V19.5'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M3.75 15L6.40125 17.6512C7.93666 19.1866 10.0154 20.0547 12.1868 20.0674C14.3581 20.08 16.4468 19.2361 18 17.7188'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_4840_711'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default RetryIcon
